<template lang="pug">
GlobalError(v-if="isEmbed")
.embed-error(v-if="isEmbed && isEmbedRedirectError")
  v-label Une erreur s'est produite lors de la redirection, cliquez pour recharger.
  v-btn.primary(@click="onReloadFromEmbed") Recharger
v-app
  .main(no-gutters)
    .content(:class="{ 'content-shifted': menuVisible }")
      slot
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'

const route = useRoute()
const userStore = useUserStore()
const navigationStore = useNavigationStore()
const isEmbedRedirectError = ref<Boolean>(false)
const reloadUrl = ref<string | null>(null)

watch(
  () => userStore.isTokenExpire,
  async (value) => {
    if (value && route?.path !== '/change-password') navigateTo('/change-password')
  },
  { immediate: true },
)

const isExternal = computed(() => {
  return navigationStore.external
})

const onReloadFromEmbed = () => {
  isEmbedRedirectError.value = false
  if (reloadUrl.value !== null) window.location.href = reloadUrl.value as string
}
</script>

<style lang="stylus" scoped>
:deep().v-application
    &__wrap
        flex-direction row !important
        overflow hidden

.embed-error
  width 100%
  height 100%
  background #fff
  position absolute
  top 0
  left 0
  z-index 10000
  display flex
  align-items center
  justify-content center
  flex-direction column
  gap 10px
  .v-label
    opacity 1
    font-size 1.2rem
    font-weight 500
    white-space pre-wrap
    text-align center
    padding 30px

.main
  display flex
  height 100%
  width 100%
  .overlay
    position absolute
    z-index 100
    height 100vh
    width 100vw
    top 0
    left 0
    background-color var(--white, #FFFFFF)
    opacity 1
    .loader
      position absolute
      top 50%
      left 50%
  .nav-bar
    width 72px
    position relative
    overflow auto
    background var(--japanese-indigo, #194355)
    display flex
    align-items center
    justify-content flex-start
    z-index 2002
  .content
    background-color var(--white, #FFFFFF)
    flex 1
    transition margin .3s ease-in-out
    width calc(100% - 72px)
</style>
